export const EMOJIS = {
  raisedHand: '✋🏻',
};

export const checkDivsInMainPanel = () => {
  // Get the main panel div
  const mainPanel = document.querySelector('#main-panel');

  if (mainPanel) {
    // Check if the hls-screen-shares div is present
    const hlsScreenShareDiv = mainPanel.querySelector('#hls-screen-shares');
    const isHlsScreenSharePresent = !!hlsScreenShareDiv;

    // Get all divs with id starting with 'OT_' inside the main panel but not inside hls-screen-shares
    const otDivs = mainPanel.querySelectorAll(
      'div[id^="OT_"]:not(#hls-screen-shares div[id^="OT_"])'
    );
    const otDivCount = otDivs.length;

    console.log(`Is hls-screen-shares present: ${isHlsScreenSharePresent}`);
    console.log(`Number of OT divs: ${otDivCount}`);

    // Return the results as an object if needed
    return {
      isHlsScreenSharePresent,
      otDivCount,
    };
  } else {
    console.log('Main panel div not found.');
    return {
      isHlsScreenSharePresent: false,
      otDivCount: 0,
    };
  }
};
